import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '../../../components/Form/Input';
import AsyncSelect from '../../../components/Form/AsyncSelect';
import { resolveCurrencyCode } from '../../../utils/currencyUtils';
import { InTransactionFormData, formatInvoiceLabel } from './inTransactionTypes';

interface InTransactionDetailsSectionProps {
  register: UseFormRegister<InTransactionFormData>;
  errors: FieldErrors<InTransactionFormData>;
  invoiceValue: string;
  onInvoiceChange: (value: string) => void;
  onInvoiceSelect: (invoice: any | null) => void;
  fetchInvoiceOptions: (query: string, page: number) => Promise<any>;
  selectedInvoice: any | null;
}

const InTransactionDetailsSection: React.FC<InTransactionDetailsSectionProps> = ({
  register,
  errors,
  invoiceValue,
  onInvoiceChange,
  onInvoiceSelect,
  fetchInvoiceOptions,
  selectedInvoice,
}) => {
  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        Transaction Details
      </h3>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <AsyncSelect
            label="Invoice"
            name="invoiceId"
            value={invoiceValue}
            onChange={onInvoiceChange}
            onSelectItem={onInvoiceSelect}
            fetchOptions={fetchInvoiceOptions}
            getOptionLabel={(inv: any) => formatInvoiceLabel(inv, resolveCurrencyCode(inv.currency))}
            getOptionValue={(inv: any) => inv.documentId || inv.id?.toString()}
            placeholder="Search invoice by number or description..."
            error={errors.invoiceId?.message}
          />
          <Input
            label="Transaction Date"
            type="date"
            {...register('transactionDate')}
            error={errors.transactionDate?.message}
          />
        </div>

        {selectedInvoice && (
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Invoice Info:</strong>{' '}
              {(() => {
                const invCurrCode = resolveCurrencyCode(selectedInvoice.currency);
                const number = selectedInvoice.invoiceNumber || `#${selectedInvoice.id}`;
                const total = Number(selectedInvoice.netTotal ?? selectedInvoice.total ?? 0).toLocaleString();
                const customer = selectedInvoice.customer?.name ? ` | ${selectedInvoice.customer.name}` : '';
                return `Invoice ${number}${customer} | Total: ${invCurrCode} ${total}`;
              })()}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InTransactionDetailsSection;
